/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/how-to/querying-data/use-static-query/
 */

import * as React from "react"
import { useStaticQuery, graphql } from "gatsby"

import Header from "./header"
import "./layout.css"
import "./custom.css"

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
      <Header siteTitle={data.site.siteMetadata?.title || `Title`} />
      <div>
        <main>{children}</main>
        <footer>
          <div className="corpFooter">
            <div style={{            
              margin: `0 auto 0`,
              maxWidth: `var(--size-content)`,
              padding: `var(--space-5) var(--size-gutter) var(--space-1)`,              
            }}>
              
              <div className="secondTier">
                <ul>
                  <li><a href="https://www.armadale.wa.gov.au" target="_blank" rel="noreferrer"><img src="/images/coa_crest_white_text.png" alt="City of Armadale logo" /></a></li>
                  <li>The City of Armadale acknowledge the Traditional Owners and the Custodians of the land upon which we stand, work and play.<br />
                      We acknowledge Aboriginal people as the First Peoples of this land and their connection to the lands and the waters, as they are part of them spiritually and culturally.
                      <br />We acknowledge their ancestors, the Elders past and present, who have led the way for us to follow.</li>
                </ul>              
              </div>
              <div className="thirdTier" style={{            
                padding: `var(--space-5) 0 0`,
              }}>
              
<div class="row">
  <div class="column left" >
  <div class="flex-container">
       
        <p>Phone<br/>
        +61&nbsp;8&nbsp;9394&nbsp;5000
        </p>
    </div>
    <div class="flex-container">
    
        <p>Address <br/>7 Orchard Avenue, Armadale<br />Western Australia 6112
        </p>
    </div>
    <div class="flex-container">
        
        <p>Email<br/>
        <a href="mailto:info@armadale.wa.gov.au">info@armadale.wa.gov.au</a>
        </p>
    </div>
  </div>
  <div class="column middle" >
  
  <div class="flex-container">
      
        <p>
        About website
        </p>
    </div>
    <div class="flex-container">
        
        <p>
        <a href="https://www.perthhillsarmadale.com.au/" target="_blank" rel="noreferrer" >Perth Hills Armadale</a>
        </p>
    </div>
    <div class="flex-container">
  
        <p>
        <a href="https://library.armadale.wa.gov.au" target="_blank" rel="noreferrer">Armadale Libraries</a>
        </p>
    </div>
    <div class="flex-container">
        
        <p>
        <a href="https://active.armadale.wa.gov.au" target="_blank" rel="noreferrer">Armadale Fitness and Aquatic Centre</a>
        </p>
    </div>
  </div>
  <div class="column right" >
  <div className="firstTier">
                <div className="btnBackground">
                  <input type="text" placeholder="Enter your email address" id="inpJoinMail"/><button id="btnJoinMail">Join mailing list</button>
                </div>
              </div>
              <div class="flex-container">
             
        <p>
        <a href="https://www.facebook.com/CityofArmadale" target="_blank" rel="noreferrer"><img src="../images/social_facebook.png" alt="Facebook logo" /></a>
                    <a href="https://www.youtube.com/channel/UCj97ywSxjtsSwWx9owKz96w" target="_blank" rel="noreferrer"><img src="../images/social_youtube.png" alt="Youtube logo" /></a>
                    <a href="https://instagram.com/cityofarmadalewa" target="_blank" rel="noreferrer"><img src="../images/social_instagram.png" alt="Instagram logo" /></a> 
        </p>
    </div>
  </div>
</div>

              </div>
            </div>
          </div>
          <div className="footerContainer"
            style={{            
              margin: `var(--space-4) auto`,
              maxWidth: `var(--size-content)`,
                       
            }}
          >
            <ul>
              <li><a href="/">Terms and Conditions</a></li>
              <li><a href="/">Privacy Statement</a></li>
              <li><a href="/">Sitemap</a></li>
              <li><a href="/">Accessibility</a></li>
              <li><a href="/">About us</a></li>
              <li>© {new Date().getFullYear()} City of Armadale</li>
            </ul>
          </div>
        </footer>  
        <div className="feedback-form">          
          <a className="show-feedback-form" href="https://forms.armadale.wa.gov.au/241135034790046" target="_blank" rel="noreferrer">&raquo;&nbsp;Recommend an Improvement</a>                    
        </div>

      </div>
    </>
  )
}

export default Layout